import React, { useState } from "react";
import TableMain from "../Common/table/TableMain";
import EwalletTableFilter from "../Common/table/EwalletTableFilter";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { EwalletService } from "../../services/ewallet/ewallet";
import SilverTableFilter from "../Common/table/SilverTableFilter";
import { Select } from "antd";

const SilverReportTable = (props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("statement");
  const [selectedStatement, setSelectedStatement] = useState(false);
  const [selectedEmoneyRequest, setSelectedEmoneyRequest] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [sortOptions, setSortOptions] = useState({ sortBy: "", direction: "" });
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [userType, setUserType] = useState('individual');
  const [pairs, setPairs] = useState('');

  //------------------------------------------- API -------------------------------------------

  // const purchaseHistory = ApiHook.CallPurchaseHistory(
  //   props.currentPage,
  //   itemsPerPage,
  //   selectedPurchase,
  //   setSelectedPurchase,
  //   sortOptions.sortBy,
  //   sortOptions.direction,
  //   activeTab
  // );

  const silverReport = EwalletService.useSilverReport(
    props.currentPage,
    itemsPerPage,
    activeTab,
    dateRange?.startDate,
    dateRange?.endDate,
    userType,
    pairs
  );
  // const requestHistory = EwalletService.useEmoneyRequestHistory(props.currentPage, itemsPerPage, activeTab);

  const handleTabChange = (tab) => {
    setSortOptions({
      sortBy: "",
      direction: "",
    });
    setActiveTab(tab);
    props.setCurrentPage(1);
    setApiTab(tab);
  };

  const setApiTab = (tab) => {
    if (tab === "transfer_history") {
      setSelectedEmoneyRequest(true);
    } else {
      setSelectedStatement(true);
    }
  };

  return (
    <div className="ewallet_table_section">
      {/* <div className="ewallet_table_section_cnt">
        <div className="ewallet_table_section_cnt_tab_head">
          <Link
            className={`ewallet_tab_btn ${activeTab === "statement" ? "active" : ""
              }`}
            onClick={() => handleTabChange("statement")}
          >
            {t("statement")}
          </Link>
          <Link
            className={`ewallet_tab_btn ${activeTab === "emoney_request" ? "active" : ""
              }`}
            onClick={() => handleTabChange("emoney_request")}
          >
            Emoney Request
          </Link>
        </div>
      </div> */}
      <div className="table-responsive min-hieght-table">
        {/* {activeTab === "statement" && ( */}
        <SilverTableFilter
          type={activeTab}
          setApiTab={setApiTab}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          setDateRange={setDateRange}
          setCurrentPage={props.setCurrentPage}
          setUserType={setUserType}
          userType={userType}
          setPairs={setPairs}
          pairs={pairs}
        />
        <TableMain
          headers={["Name", "Phone", "Left", "Right"]}
          data={silverReport?.data?.data}
          startPage={1}
          currentPage={props.currentPage}
          totalPages={silverReport?.data?.totalPages}
          setCurrentPage={props.setCurrentPage}
          type={"silver_report"}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          activeTab={activeTab}
          setApiTab={setApiTab}
          setEpinSortOptions={setSortOptions}
        />
        {/* )} */}
      </div>
    </div>
  );
};

export default SilverReportTable;
